const competitiveMilestones = [
  ["request", "Request", "Purchase requested"],
  ["approval", "Approval", "Request approved"],
  ["source", "Sourcing", "Sourcing event created"],
  ["order", "Award & order", "Supplier awarded and order created"],
  ["supplier", "Supplier", "Supplier acknowledged order"],
  ["receipt", "Receipt", "Goods received"],
  ["acceptance", "Acceptance", "Operational acceptance recorded"],
  ["invoice", "Invoice", "Invoice recorded"],
  ["match", "Match", "Invoice matched"],
  ["payment", "Payment evidence", "Payment completion recorded"],
  ["reconciliation", "Reconciliation", "Payment reconciled"],
  ["closure", "Closure", "Procurement case closed"],
  ["file_note", "File note", "File note sealed"],
  ["audit_pack", "Audit pack", "Audit pack sealed"],
];

const directMilestones = competitiveMilestones.filter(
  ([key]) => key !== "source",
);

function normalise(value) {
  return String(value || "").trim().toLowerCase();
}

function eventMatches(event, key) {
  const title = normalise(event.title);
  const summary = normalise(event.summary);
  const stage = normalise(event.stage);
  if (key === "request") return stage === "request";
  if (key === "approval") return title === "request approved";
  if (key === "source") return stage === "source";
  if (key === "order") return stage === "award" || stage === "order";
  if (key === "supplier") return title === "supplier acknowledged order";
  if (key === "receipt") return title === "goods received";
  if (key === "acceptance")
    return (
      stage === "fulfil" &&
      /(acceptance|inspection|installation|commissioning|service delivery)/.test(
        title,
      )
    );
  if (key === "invoice") return title === "invoice recorded";
  if (key === "match") return title === "invoice matched";
  if (key === "payment") return title === "payment completion recorded";
  if (key === "reconciliation") return title === "payment reconciled";
  if (key === "closure") return title === "procurement case closed";
  if (key === "file_note")
    return title === "file note sealed" || summary.includes("file_note");
  if (key === "audit_pack")
    return title === "audit pack sealed" || summary.includes("audit_pack");
  return false;
}

export function isDirectProcurementRoute(route) {
  return [
    "direct_purchase",
    "external_purchase_order",
    "emergency_purchase",
  ].includes(route);
}

export function goldenJourneyProgress(journey) {
  const definitions = isDirectProcurementRoute(journey.route)
    ? directMilestones
    : competitiveMilestones;
  const events = Array.isArray(journey.events) ? journey.events : [];
  const milestones = definitions.map(([key, label, expected]) => {
    const evidence = events.find((event) => eventMatches(event, key));
    return { key, label, expected, complete: Boolean(evidence), evidence };
  });
  const completed = milestones.filter((item) => item.complete).length;
  const next = milestones.find((item) => !item.complete) || null;
  return {
    completed,
    total: milestones.length,
    complete: completed === milestones.length,
    percent: Math.round((completed / milestones.length) * 100),
    next,
    milestones,
  };
}

